// extracted by mini-css-extract-plugin
module.exports = {"sectionHeadline":"FeaturedCarsSlider-module__sectionHeadline___1mT_V"};